module.exports = __webpack_public_path__ + "media/images/poor_smiley-14ca56184d2762a4312ee802b2ea5364.svg";